import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import tooltip from 'simple-tooltip';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import updateTodoMixin from 'next/javascripts/mixins/update-todo-mixin';
import { closest } from 'next/javascripts/modules/dom';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

Component('tr-kanban-todo', {
  mixins: [eventListenerMixin, updateTodoMixin],

  properties: {
    completed: Boolean,
    todoDetailUrl: String,
    todoItemUrl: String,
    guid: String,
    sequence: String,
    editing: Boolean,
    showAssigneeName: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      mouseover: this.handleAssigneeMouseover.bind(this),
      mouseout: this.handleAssigneeMouseout.bind(this),
      'tao:opened': () => { this.editing = true; },
      'tao:closed': () => { this.editing = false; },
    });

    this.subscription = resourceSubject('todo').subscribe({
      next: (event, { guid }) => {
        if (event === 'update' && guid && guid === this.guid) {
          $.getScript(this.todoItemUrl);
        }
      },
    });
  },

  handleClick(event) {
    if (window.tower.metaKey(event)) {
      window.open(this.todoDetailUrl);
      return;
    }

    if (!closest(event.target, '.js-dont-open-page', this)
      && !this.namespacedTrigger('openpage',
        { bubbles: true, detail: { url: this.todoDetailUrl } })) {
      event.preventDefault();
      event.stopPropagation();
    }
  },

  handleAssigneeMouseover(event) {
    const assigneeSelect = closest(event.target, '.assignee-selector');
    if (!assigneeSelect || this.showAssigneeName) return;

    const assigneeResult = assigneeSelect
      .querySelector('.selector-field-result .selected-text');
    if (!assigneeResult || assigneeResult.hasAttribute('data-no-assignee')) return;

    if (this.tooltipHovering) {
      this.tooltipHovering = false;
      return;
    }

    $('.simple-tooltip').remove();

    this.tooltip = tooltip({
      el: assigneeSelect,
      content: assigneeResult.querySelector('.text').textContent,
      position: 'right',
    });
    this.tooltip.el.addClass('todo-item-assignee-tooltip');

    this.tooltip.show();
  },

  handleAssigneeMouseout(event) {
    if (event.relatedTarget
      && closest(event.relatedTarget, '.todo-item-assignee-tooltip')) {
      this.tooltipHovering = true;
    }

    if (!this.showAssigneeName) this.destroyAssigneeTooltip();
  },

  destroyAssigneeTooltip() {
    if (this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
  },

  disconnected() {
    this.destroyAssigneeTooltip();
    this.stopListening();
    if (this.subscription) this.subscription.unsubscribe();
  },
});
